import { render, staticRenderFns } from "./Viggle.vue?vue&type=template&id=7423f112&scoped=true"
import script from "./Viggle.vue?vue&type=script&lang=js"
export * from "./Viggle.vue?vue&type=script&lang=js"
import style0 from "./Viggle.vue?vue&type=style&index=0&id=7423f112&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7423f112",
  null
  
)

export default component.exports